module.exports = __webpack_public_path__ + "images/emoji/symbols.a40f56f77784ecc8eb7e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/symbols.png
// module id = +jAh
// module chunks = 13